<template>
  <div class="content voucher-template-list">
    <div class="form-content">
      <a-row :gutter="16">
        <a-col :span="6">
          <a-input
            allow-clear
            v-model.trim="formData.template_name"
            :placeholder="$t('模板名称')"
            @pressEnter="queryList(1)"
          />
        </a-col>
        <a-col :span="6">
          <a-input
            allow-clear
            v-model.trim="formData.template_code"
            :placeholder="$t('模板编码')"
            @pressEnter="queryList(1)"
          />
        </a-col>
        <a-col :span="6">
          <CommonSelect
            :list="document_type"
            :code.sync="formData.doc"
            :placeholder="$t('对应单据')"
          />
        </a-col>
        <a-col :span="6">
          <a-button @click="queryList(1)" type="primary">
            <i class="iconfont" style="margin-right: 5px">&#xe647;</i>
            {{ $t(`查询`) }}
          </a-button>
          <a-button @click="reset" style="margin-left: 10px">
            <a-icon type="redo" />
            {{ $t(`重置`) }}
          </a-button>
        </a-col>
      </a-row>
    </div>

    <div class="table-content">
      <div class="table-header">
        <div class="btns flex-ct gap10">
          <a-button type="primary" @click="handleAdd">
            <i class="icon iconfont icon-new" style="margin-right: 5px"></i>
            {{ $t('新增模板') }}
          </a-button>
          <TableSetting :columns="columns" @change="changeColumns" />
        </div>
      </div>
      <div class="table-body">
        <a-table
          size="small"
          :columns="showColumns"
          :loading="loading"
          :dataSource="tableData"
          :pagination="false"
          rowKey="id"
          :scroll="{ y: scrollHeight }"
        >
          <template slot="no" slot-scope="text, record, index">
            <span>{{ index + 1 + (pageNo - 1) * pageSize }}</span>
          </template>
          <template slot="doc" slot-scope="text">
            {{ documentTypeMapping[text] || text }}
          </template>
          <template slot="created_at" slot-scope="text, record">
            <div>{{ record.created_user }}</div>
            <div>{{ text }}</div>
          </template>
          <template slot="voucherType" slot-scope="text">
            {{ journalVoucherTypeMapping[text] || text }}
          </template>
          <template slot="action" slot-scope="text, record">
            <span class="text-link" @click="handleEdit(record)">{{ $t('详情') }}</span>
            <a-divider type="vertical" />
            <span class="text-link" @click="handleCopy(record)">{{ $t('复制') }}</span>
            <a-divider type="vertical" />
            <span class="text-link" @click="handleDelete(record)">{{ $t('删除') }}</span>
          </template>
        </a-table>
      </div>
      <div class="table-footer mt10">
        <pagination
          :pageNo="pageNo"
          :length="pageSize"
          :total-count="total"
          @paginate="paginate"
        ></pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import http from '@/service/axios'
import api from '@/service/api'
import pagination from '@/component/pagination.vue'
import TableSetting from '@/component/tableSetting.vue'

export default {
  name: 'VoucherTemplateList',
  components: { pagination, TableSetting },
  data() {
    return {
      formData: {
        template_name: undefined,
        template_code: undefined,
        doc: undefined,
      },
      tableData: [],
      loading: false,
      total: 0,
      pageNo: 1,
      pageSize: 20,
      columns: [],
    }
  },
  mounted() {
    this.setColumns()

    http({
      url: api.getFinanceDocumentField,
      data: {
        financeDocumentCode: 'PaymentNote',
      },
    })
  },
  activated() {
    this.queryList()
  },
  computed: {
    ...mapState(['document_type']),
    ...mapGetters(['documentTypeMapping', 'journalVoucherTypeMapping']),
    showColumns() {
      return [
        {
          title: '#',
          align: 'center',
          key: 'NO',
          width: 60,
          scopedSlots: {
            customRender: 'no',
          },
        },
        ...this.columns,
        {
          title: this.$t('操作'),
          key: 'action',
          width: 150,
          scopedSlots: {
            customRender: 'action',
          },
        },
      ]
    },
    scrollHeight() {
      return window.innerHeight - 400
    },
  },
  methods: {
    reset() {
      this.formData = {
        template_name: undefined,
        template_code: undefined,
        doc: undefined,
      }
      this.pageNo = 1
      this.queryList()
    },
    setColumns() {
      this.columns = [
        {
          title: this.$t('模板名称'),
          dataIndex: 'template_name',
          width: 250,
        },
        {
          title: this.$t('模板编码'),
          dataIndex: 'template_code',
          width: 120,
        },
        {
          title: this.$t('对应单据'),
          dataIndex: 'doc',
          width: 150,
          scopedSlots: {
            customRender: 'doc',
          },
        },
        {
          title: this.$t('凭证字'),
          dataIndex: 'voucher_type',
          width: 80,
          scopedSlots: {
            customRender: 'voucherType',
          },
        },
        {
          title: this.$t('科目表'),
          dataIndex: 'account_table_name',
          width: 150,
        },
        {
          title: this.$t('记账日期规则'),
          dataIndex: 'accounting_date',
          width: 150,
        },
        {
          title: this.$t('业务日期规则'),
          dataIndex: 'biz_date',
          width: 150,
        },
        // {
        //   title: this.$t('创建人'),
        //   dataIndex: 'created_user',
        //   width: 120,
        // },
        {
          title: this.$t('创建时间'),
          dataIndex: 'created_at',
          width: 180,
          scopedSlots: {
            customRender: 'created_at',
          },
        },
      ]
    },
    paginate(data) {
      this.pageNo = data.pageNo
      this.pageSize = data.pageSize
      this.queryList()
    },
    queryList(pageNo = 0) {
      if (pageNo) {
        this.pageNo = pageNo
      }
      this.loading = true
      http({
        url: api.getVoucherTemplateList,
        data: {
          page_no: this.pageNo,
          page_size: this.pageSize,
          ...this.formData,
        },
        success: (res) => {
          this.tableData = res.result.list || []
          this.total = res.result.total || 0
          this.loading = false
        },
        fail: (err) => {
          this.$message.error(err.msg || this.$t('获取列表失败'))
          this.loading = false
        },
      })
    },
    changeColumns(list) {
      this.columns = list
    },
    handleAdd() {
      this.$router.push({
        path: '/voucherManage/voucherTemplateDetail',
      })
    },
    handleEdit(record) {
      this.$router.push({
        path: '/voucherManage/voucherTemplateDetail',
        query: { id: record.id },
      })
    },
    handleCopy(record) {
      this.$router.push({
        path: '/voucherManage/voucherTemplateDetail',
        query: { copyId: record.id },
      })
    },
    handleDelete(record) {
      this.$confirm({
        title: this.$t('提示'),
        content: this.$t('确定要删除吗？'),
        okText: this.$t('确定'),
        cancelText: this.$t('取消'),
        onOk: () => {
          http({
            url: api.deleteVoucherTemplate,
            data: {
              id: record.id,
            },
            success: () => {
              this.$message.success(this.$t('删除成功'))
              this.queryList()
            },
            fail: (err) => {
              this.$message.error(err.msg || this.$t('删除失败'))
            },
          })
        },
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.voucher-template-list {
  .disabled {
    color: #ccc;
    cursor: not-allowed;
  }
}
</style>
